import { getOrderEmbeddedPaymentStatus } from './get-order-embedded-payment-status';
/**
 * Gets a value indicating whether the order has an in-progress embedded payment.
 */
export const orderHasInProgressEmbeddedPayment = () => {
    const status = getOrderEmbeddedPaymentStatus();
    return status === 'Created' || status === 'Started';
};
//# sourceMappingURL=order-has-in-progress-embedded-payment.js.map